import type { InterpretationRule, InterpretationRuleDB } from './@types/InterpretationRuleModel';
export class InterpretationRulesRepository {
    private httpService: IHttpService;
    constructor(instance: IHttpService) {
        this.httpService = instance;
    }

    async getAll(): Promise<InterpretationRuleDB[]> {
        try {
            const response = await this.httpService.get<TKResponse<InterpretationRuleDB[]>>('/interpretation_rules');
            const data = response.data.map((rule) => ({ ...rule, id: rule.interpretation_rule_id }));
            return data.sort((a, b) => ((a as any).name ?? '').localeCompare((b as any).name ?? ''));
        } catch (error) {
            console.error('Error al obtener las interpretation_rules:', error);
            throw error;
        }
    }
    async get(id: number): Promise<InterpretationRuleDB> {
        try {
            const response = await this.httpService.get<TKResponse<InterpretationRuleDB>>(`/interpretation_rules/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error al obtener la interpretation_rule por ID:', error);
            throw error;
        }
    }
    async create(data: InterpretationRule): Promise<{ data: InterpretationRuleDB, status: number }> {
        try {
            const response = await this.httpService.post<InterpretationRuleDB, InterpretationRule>('/interpretation_rules', { data });
            return { data: response, status: 200 };
        } catch (error) {
            console.error("Error creating interpretation rule:", error);
            throw error;
        }
    }
    async update(id: number, data: InterpretationRule): Promise<{ data: InterpretationRuleDB, status: number }> {
        try {
            const response = await this.httpService.patch<InterpretationRuleDB, InterpretationRule>(`/interpretation_rules/${id}`, { data });
            return { data: response, status: 200 };
        } catch (error) {
            console.error("Error updating interpretation rule:", error);
            throw error;
        }
    }
    async delete(id: number): Promise<void> {
        try {
            await this.httpService.delete(`/interpretation_rules/${id}`);
        }
        catch (error) {
            console.error("Error deleting interpretation rule:", error);
            throw error;
        }
    }

}